module.exports = __webpack_public_path__ + "9089b8e3e7a3c0ed474f01050b300fa8.svg";